import { Button } from "flowbite-react";
import { useSearchParams } from "react-router-dom";
import PromotionalPanel from "./PromotionalPanel";

interface ThankYouViewProps {
    type: "VERIFY" | "RESET";
}

const ThankYouView = ({ type }: ThankYouViewProps) => {
    const [searchParams] = useSearchParams();
    const email = searchParams.get("email");
    const options = {
        message: type === "VERIFY" ? "verify your account" : "reset your password",
        buttonText: type === "VERIFY" ? "Open Email App & Confirm" : "Go back to main page",
        buttonHref: type === "VERIFY" ? "/account/sign-up" : "/",
    };

    return (
        <div className='min-h-screen w-full flex overflow-hidden '>
            <div className='w-full min-h-full flex flex-col gap-4 lg:gap-0 lg:flex-row bg-black/30 lg:bg-transparent lg:p-8'>
                <PromotionalPanel
                    title='A new way to buy and sell cars'
                    imageUrl='/bg-car.png'
                    cta={{
                        title: "Do you already have an account?",
                        text: "Sign In",
                        url: "/account/sign-in",
                    }}
                />

                <div className='flex-1 flex flex-col justify-center items-center p-4 lg:p-8 lg:bg-white'>
                    <div className='mb-6 mx-auto flex flex-col text-center'>
                        <img
                            alt={""}
                            loading='lazy'
                            src='/recovery-lock.png'
                            className='aspect-square object-contain object-center w-3/4 justify-center items-center overflow-hidden self-center max-w-full'
                        />
                        <h2 className='text-3xl font-bold text-white lg:text-black'>Thank you!</h2>
                        <p className='text-sm text-gray-300 lg:text-gray-500 mt-6'>
                            We sent an email to {email} <br /> Click confirmation link in the email to {options.message}
                        </p>
                    </div>

                    <Button
                        href={options.buttonHref}
                        type='submit'
                        color='light'
                        fullSized
                        className='xl:w-1/2 w-full flex items-center justify-center bg-purple-500 text-white py-3'>
                        {options.buttonText}
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default ThankYouView;